export default function MessageTextIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M1.66663 11.3082V6.32484C1.66663 4.02484 3.53329 2.1665 5.83329 2.1665H14.1666C16.4666 2.1665 18.3333 4.02484 18.3333 6.32484V12.1415C18.3333 14.4332 16.4666 16.2915 14.1666 16.2915H12.9166C12.6583 16.2915 12.4083 16.4165 12.25 16.6248L11 18.2832C10.45 19.0165 9.54996 19.0165 8.99996 18.2832L7.74996 16.6248C7.61663 16.4415 7.31663 16.2915 7.08329 16.2915H5.83329C3.53329 16.2915 1.66663 14.4332 1.66663 12.1415V11.3082Z"
        fill="currentColor"
      />
      <path
        d="M14.1667 7.7915H5.83337C5.49171 7.7915 5.20837 7.50817 5.20837 7.1665C5.20837 6.82484 5.49171 6.5415 5.83337 6.5415H14.1667C14.5084 6.5415 14.7917 6.82484 14.7917 7.1665C14.7917 7.50817 14.5084 7.7915 14.1667 7.7915ZM10.8334 11.9582H5.83337C5.49171 11.9582 5.20837 11.6748 5.20837 11.3332C5.20837 10.9915 5.49171 10.7082 5.83337 10.7082H10.8334C11.175 10.7082 11.4584 10.9915 11.4584 11.3332C11.4584 11.6748 11.175 11.9582 10.8334 11.9582Z"
        fill="currentColor"
      />
    </svg>
  );
}
